/**
 * linien um die drei räder
 */

import { Timer } from "@goodgamestudios/createjs-utilities";

import MovieClip = createjs.MovieClip;
import TimerEvent = createjs.TimerEvent;

export class Poker2BanditWinnAnimation {
    private PLAY_DURATION: number = 4000; // millisekunden die animation zeigen

    private disp: MovieClip;
    private timer: Timer;

    /**
     * @param disp
     */
    constructor(disp: MovieClip) {
        this.disp = disp;
        this.timer = new Timer(this.PLAY_DURATION, 1);
    }

    /**
     * alles deinstallieren
     */
    public destroy(): void {
        this.timer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.eventTimer));
    }

    /**
     * nach der zeit animation weg
     * @param event	unbenutzt
     */
    private eventTimer(event: TimerEvent): void {
        this.hide();
    }

    public hide(): void {
        this.timer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.eventTimer));
        this.disp.gotoAndStop(1);
    }

    public play(): void {
        this.disp.play();
        this.timer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.eventTimer));
        this.timer.start();
    }

    //
    // ende
    //
}
